import { render, staticRenderFns } from "./CreateStandardWorkInstructionModal.vue?vue&type=template&id=7608961f&scoped=true"
import script from "./CreateStandardWorkInstructionModal.vue?vue&type=script&lang=js"
export * from "./CreateStandardWorkInstructionModal.vue?vue&type=script&lang=js"
import style0 from "./CreateStandardWorkInstructionModal.vue?vue&type=style&index=0&id=7608961f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7608961f",
  null
  
)

export default component.exports